import { gql } from "apollo-boost"

export const BLOCKING_SCHEDULE_PLACE = gql`
  mutation Mutation($schedulePlaceId: [ID!]!, $isBlocking: Boolean!) {
  BlockingSchedulePlace(schedulePlaceId: $schedulePlaceId, isBlocking: $isBlocking)
}
`